import { InjectionToken } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';

export const ControlListenerPluginToken = new InjectionToken<ControlListenerPlugin<any>>('ControlListenerPlugin');

export interface ControlListenerPlugin<C> {
  connect(config: C, ctrl: AbstractControl, form: UntypedFormGroup, valueChanges$?: Observable<any>): Observable<any>;
  // TODO: create destroy method and implement on children
}
